export default __webpack_public_path__ + "static/media/pr.d243c197.svg";